export enum BUTTONSIZE {
    SIZE20 = '20',
    SIZE24 = '24',
    SIZE32 = '32',
    SIZE36 = '36',
    SIZE40 = '40',
    SIZE48 = '48',
    SIZE60 = '60',
};